import React, {useEffect, useState} from 'react';
import {Divider, Grid, Typography} from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import api from '../core/api';

const rowStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  height: 100,
};

const colStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: 100,
  marginTop: 10,
};

const CountDetailsBusiness = () => {
  const [businessCount, setBusinessCount] = useState();

  const handlerCountDatails = async () => {
    const count = await api.get('/business/count');
    setBusinessCount(count.data);
  };

  useEffect(() => {
    handlerCountDatails();
  }, []);

  return (
    <div style={{...rowStyle, paddingTop: 20}}>
      <div style={colStyle}>
        <Typography component="h1" variant="subtitle1" color="inherit" noWrap>
          USUÁRIOS
        </Typography>
        <InputLabel htmlFor="age-native-helper"></InputLabel>
        <div style={rowStyle}>
          <div style={{minWidth: '100px'}}>
            <InputLabel htmlFor="age-native-helper">
              Total de empresas
            </InputLabel>
            <InputLabel style={{fontWeight: 'bold'}}>
              {businessCount?.business_total}
            </InputLabel>
          </div>

          <div style={{minWidth: '100px', marginLeft: 15}}>
            <InputLabel htmlFor="age-native-helper">
              Total de usuários B2B
            </InputLabel>
            <InputLabel style={{fontWeight: 'bold'}}>
              {businessCount?.users_b2b}
            </InputLabel>
          </div>
        </div>
      </div>
      <Divider orientation="vertical" style={{marginLeft: 10}} />

      <div style={colStyle}>
        <Typography component="h1" variant="subtitle1" color="inherit" noWrap>
          PLANOS
        </Typography>
        <div style={rowStyle}>
          <div style={{minWidth: '100px', marginLeft: 15}}>
            <InputLabel htmlFor="age-native-helper">
              Usuário plano mensal B2B
            </InputLabel>
            <InputLabel style={{fontWeight: 'bold'}}>
              {businessCount?.users_b2b_monthly}
            </InputLabel>
          </div>
          <div style={{minWidth: '100px', marginLeft: 15}}>
            <InputLabel htmlFor="age-native-helper">
              Usuário plano anual B2B
            </InputLabel>
            <InputLabel style={{fontWeight: 'bold'}}>
              {businessCount?.users_b2b_yearly}
            </InputLabel>
          </div>
          <div style={{minWidth: '100px', marginLeft: 15}}>
            <InputLabel htmlFor="age-native-helper">
              Usuário Special B2B
            </InputLabel>
            <InputLabel style={{fontWeight: 'bold'}}>
              {businessCount?.users_b2b_special}
            </InputLabel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountDetailsBusiness;
